import { createQueryKeys } from '@lukemorales/query-key-factory';
import apiService from '@services/base/apiService';
import { env } from '@configuration-lib';

const aspClassicUrl = env.VUE_APP_ASP_CLASSIC_BASE;
const userToken = env.VUE_APP_USER_TOKEN ? `?gebruiker_token=${env.VUE_APP_USER_TOKEN}` : '';

export const menuQueries = createQueryKeys('menu', {
  getMenuItems: () => ({
    queryKey: ['items'],
    queryFn: () => apiService.apiClient.get(`${aspClassicUrl}/content/ajax/getMenuItems/${userToken}`)
  }),
  getCrvp: () => ({
    queryKey: ['crvp'],
    queryFn: () => apiService.apiClient.get(`${aspClassicUrl}/content/ajax/GetPortefeuilleDashboard/${userToken}`)
  })
});
